module.exports = __webpack_public_path__ + "media/my_images/detail/zinzai-b5ae6db6ef80d8d7cc83701a06b1e52a.svg";